import { HomeOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { createElement } from 'react';
import type { TFunction } from 'i18next';

import type { UserRole } from '@/api/generated/model';
import { hasRole } from '@/auth/roles';
import { HOME, SECTIONS } from '@/sections';

type MenuItem = Required<MenuProps>['items'][number];

/** Меню по роли: разделы без доступа не показываются вовсе. */
export function menuItems(t: TFunction, role: UserRole): MenuItem[] {
  const items: MenuItem[] = [
    { key: HOME, icon: createElement(HomeOutlined), label: t('menu.home') },
  ];
  const groups = new Map<string, MenuItem[]>();
  for (const s of SECTIONS) {
    if (!hasRole(role, s.minRole)) continue;
    const item: MenuItem = { key: s.path, icon: s.icon, label: t(s.labelKey) };
    if (!s.groupKey) {
      items.push(item);
      continue;
    }
    let children = groups.get(s.groupKey);
    if (!children) {
      children = [];
      groups.set(s.groupKey, children);
      items.push({ key: s.groupKey, label: t(s.groupKey), type: 'group', children });
    }
    children.push(item);
  }
  return items;
}
